export default __webpack_public_path__ + "static/media/leistungsangebot_abschnitt01.ceccf313.jpg";